import React from 'react';
import {Link} from 'react-router-dom';
import {DateTime} from 'components/UI/DateTime';
import {User} from 'api';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {NoContent} from 'components/no-content';
import ItemDemand from './ItemDemand.jsx';
import {connect} from 'react-redux';
import './_MyDemandContent.scss';

class ComplaintContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false,
      count: 0,
      skip: 0,
      limit: 10
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.user) {
      this.setState({isLoading: true});
      User.actions.countDemand.request({id: this.props.user.id}).then((response) => {
        this.setState({count: response.data.count, isLoading: false});
        this.getList();
      }).catch((error) => {
        this.setState({isLoading: false});
      });
    }
  }

  getList() {
    if (this.props.user) {
      this.setState({isLoading: true});
      let params = {
        id: this.props.user.id,
        filter: {
          limit: this.state.limit,
          skip: this.state.skip,
          order: 'createdAt DESC',
          include: 'categories'
        }
      };
      User.actions.demands.request(params).then(response => {
        let demands = this.state.data;
        response.data.map((item, idx) => {
          demands.push(item);
        });
        this.setState({data: demands, isLoading: false});
      }).catch(() => {
        this.setState({isLoading: false});
      });
    }
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  render() {
    return (
      <section className="my-posted-demand">
        <LoadingPage isShow={this.state.isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <div className="list-demand">
            {
              this.state.data.map((item, idx)=> {
                return (
                  <ItemDemand key={idx} {...item}/>
                );
              })
            }
            <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
              <div className="btn-see-more-wrap p20">
                <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
              </div>
            </ShowIf>
          </div>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length == 0}>
          <NoContent content='Không có nhu cầu nào' height={680}/>
        </ShowIf>
      </section>
    );
  }
}

const mapStateToProp = (state) => {
  return {
    user: state.auth.user
  };
};

export default connect(mapStateToProp)(ComplaintContent);



// WEBPACK FOOTER //
// ./components/users/my-demand-content/MyDemandContent.jsx